export default __webpack_public_path__ + "static/media/43-Hilton.cf451654.jpg";